import { format, toZonedTime } from 'date-fns-tz';

// Function to format a timestamp to Indian Standard Time (IST)
export const formatToIST = (timestamp) => {
  if (!timestamp) return "N/A";
  try {
    const utcTimestamp = timestamp.endsWith('Z') ? timestamp : `${timestamp}Z`;
    const istTime = toZonedTime(new Date(utcTimestamp), 'Asia/Kolkata');
    return format(istTime, 'dd MMM yyyy, h:mm a', { timeZone: 'Asia/Kolkata' });
  } catch (error) {
    console.error("Error formatting timestamp:", error);
    return "Invalid Date";
  }
};

// Helper function to get system details by UUID
export const getSystemDetails = (systems, uuid) => {
  return systems.find(system => system.uuid === uuid) || null;
};
